/*
 * File: PhoneView.js
 * Project: mp-mobile-app
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description: Handles the phone numbers and phone types for viewing on the patient property list
 */
import React from "react";
import UIPhoneLink from "components/ui/UIPhoneLink";
import UIListItem from "components/ui/UIListItem";
import PropTypes from "prop-types";

const PhoneView = ({ phone1, phone2, phone3 }) => {
  const getPhoneType = phone => {
    if (phone.type === 0) return "Home Phone";
    if (phone.type === 1) return "Work Phone";
    if (phone.type === 2) return "Mobile Phone";
    if (phone.type === 3) return "Other Phone";
  };

  const getPhoneNumber = phone => {
    if (!phone || !phone.number) return "";
    return phone.number;
  };

  return (
    <React.Fragment>
      {!phone1 && !phone2 && !phone3 && <UIListItem label="Phone" value="" />}
      {phone1 && (
        <UIListItem
          label={getPhoneType(phone1)}
          value={<UIPhoneLink phone={getPhoneNumber(phone1)} />}
        />
      )}
      {phone2 && (
        <UIListItem
          label={getPhoneType(phone2)}
          value={<UIPhoneLink phone={getPhoneNumber(phone2)} />}
        />
      )}
      {phone3 && (
        <UIListItem
          label={getPhoneType(phone3)}
          value={<UIPhoneLink phone={getPhoneNumber(phone3)} />}
        />
      )}
    </React.Fragment>
  );
};

PhoneView.propTypes = {
  phone1: PropTypes.object,
  phone2: PropTypes.object,
  phone3: PropTypes.object
};

export default PhoneView;
